import React, { useState } from 'react';

import {
  FormControl,
  Box,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export default function AWSAccountSecretField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Secret cannot be blank');
    } else {
      setError(false);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <InputLabel htmlFor='password'>Account Secret</InputLabel>
        <OutlinedInput
          label='Account Secret'
          id='secret'
          type={showPassword ? 'text' : 'password'}
          aria-describedby='secret-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton
                aria-label='toggle secret visibility'
                onClick={handleClickShowPassword}
                edge='end'
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        {error ? (
          <FormHelperText id='secret-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='secret-helper-text'>
            Enter the proxiML IAM user AWS Account Secret
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
